import io from 'socket.io-client';
import config from '../config';

const createSocket = () => io({
  path: `${config.BASE_PATH}/api/socket-io`,
  transports: ['websocket'], // remove when testing on localhost
  extraHeaders: { // remove when testing on localhost
    Connection: 'upgrade', // remove when testing on localhost
    Upgrade: 'websocket', // remove when testing on localhost
  },
});

export const emitPromise = socket => (event, data) =>
  new Promise(
    resolve => {
      console.log('Emitting event', event, data); // eslint-disable-line no-console
      socket.emit(event, data, response => {
        console.log('Got event response', event, response); // eslint-disable-line no-console
        resolve(response);
      });
    }
  );


export default createSocket;
